import React from 'react'
import Style from './Brands.module.css'
import useAllBrands from '../../hooks/useAllBrands'
import Loading from '../Loading/Loading';
import Error from '../Error/Error';
import {Helmet} from "react-helmet";

export default function Brands() {
  const { isLoading, isError, data } = useAllBrands();


  const openModal = () => {

  }

  return <>
   <Helmet>
      <meta charSet="utf-8" />
      <title>Brands</title>
    </Helmet>
    {isLoading && <Loading />}
    {data && <div className='row gy-3 my-3'>
      {data?.data.data.map((brand) => {
        const modalId = `exampleModal-${brand._id}`
        return <div key={brand._id} className='col-md-3'>

          <div className="brand py-3" type="button" data-bs-toggle="modal" data-bs-target={`#${modalId}`}>
            <img src={brand.image} alt={brand.name} />
            <h3 className='text-center h6 fw-bolder'>{brand.name}</h3>
          </div>
          <div className="modal fade" id={modalId} tabIndex={-1} aria-labelledby={`${modalId}Label`} aria-hidden="true">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                </div>
                <div className="modal-body py-4">
                  <div className='d-flex justify-content-between align-items-center'>
                    <div className='d-flex flex-column'>
                      <h2 className='text-main fw-bolder'>{brand.name}</h2>
                      <h6 className=''>{brand.name}</h6>
                    </div>
                    <img src={brand.image} alt={brand.name} />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-light" data-bs-dismiss="modal">Close</button>
                </div>
              </div>
            </div>
          </div>



        </div>
      })}
    </div >}
    {isError && <Error />}
  </>

}